/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_ExpiredInputs */



/**
* | output |
* | --- |
* | "Expired" |
*
* @param {Sanction_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_expired = /** @type {((inputs?: Sanction_ExpiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_ExpiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Expirée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expirada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Expirada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scaduta")
	return /** @type {LocalizedString} */ ("Expired")
});